import { Component } from '@angular/core';
import { orders } from 'src/app/resources/orders';
import { Order } from 'src/app/models/order.model';
import { Site } from 'src/app/models/site.model';

@Component({
    selector: 'app-dashboard-ivtm-component',
    templateUrl: './dashboard-ivtm.component.html'
})
export class DashboardIVTMComponent {
    public selectedChart: 'Trend' | 'Volume' = 'Trend';
    public orders: Order[] = orders;

    public listItemsLocais: Array<Site> =[];

}
